import React from 'react';
import PropTypes from 'prop-types';
import { Result } from 'antd';


const propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
};

const defaultProps = {
    title: 'There were some problems retrieving your list of bookings.',
    subTitle: 'Try refreshing the page. If the problem still persists, please contact your website administrator.',
};

const SearchBookingsError = ({ title, subTitle }) => {
    return (
        <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Result
                status="warning"
                title={title}
                subTitle={subTitle}
            />
        </div>
    );
};

SearchBookingsError.propTypes = propTypes;
SearchBookingsError.defaultProps = defaultProps;

export default SearchBookingsError;

